import styles from "./styles/Confirmation.module.css";
import React, { useEffect, useState } from "react";
function Confirmation({
  onClose,
  title,
  text,
  OnConfirm,
  confirm_button = "Delete",
  cancel_button = "Cancel",
  confirm_color = "#e45050",
  close_button = "",
}) {
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  const confirmAction = () => {
    OnConfirm();
    setDisabled(true);
  };
  console.log(text);
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>{title}</div>
        <div className={styles.main_data}>
          {text.split("/")[0]}
          <br />
          {text.split("/")[1]}

          <div className={styles.buttons_div}>
            {/* <div onClick={()=>null} className={styles.delete_button}>Delete</div> */}
            {close_button !== "none" && (
              <div onClick={onClose} className={styles.cancel_button}>
                {cancel_button}
              </div>
            )}
            {/* <div onClick={(e)=>null} className={styles.save_button}>Save</div> */}
            <button
              disabled={disabled}
              onClick={() => confirmAction()}
              className={styles.delete_button}
            >
              {confirm_button}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
